import { PerformanceDisclaimerTranslations } from '../types';

/**
 * Resolves a period string from translations for the given period key.
 * Reuses existing stop_order_valid_* translations for day/days/month/months,
 * and performance_disclaimer_period_year/years for year periods.
 */
const periodResolvers: Record<
  string,
  (t: PerformanceDisclaimerTranslations) => string
> = {
  '24h': () => '24h',
  '1week': (t) => t.periodDays.replace('{{amount}}', '7'),
  '1month': (t) => t.periodMonth.replace('{{amount}}', '1'),
  '6months': (t) => t.periodMonths.replace('{{amount}}', '6'),
  '1year': (t) => t.periodYear.replace('{{amount}}', '1'),
  '5years': (t) => t.periodYears.replace('{{amount}}', '5'),
};

/**
 * Maps AssetsListSortBy values (used in prices list) to period keys.
 */
export const sortByToPeriodKey: Record<string, string | undefined> = {
  PRICE_CHANGE_24HOURS: '24h',
  PRICE_CHANGE_1WEEK: '1week',
  PRICE_CHANGE_1MONTH: '1month',
  PRICE_CHANGE_1YEAR: '1year',
};

/**
 * Maps TimeAmounts enum values (used in asset details chart) to period keys.
 */
export const timeAmountToPeriodKey: Record<string, string | undefined> = {
  oneDay: '24h',
  sevenDays: '1week',
  oneMonth: '1month',
  sixMonths: '6months',
  oneYear: '1year',
  maxYears: '5years',
};

/**
 * Maps PortfolioPeriod values (used in portfolio context) to period keys.
 */
export const portfolioPeriodToPeriodKey: Record<string, string | undefined> = {
  DAY: '24h',
  WEEK: '1week',
  MONTH: '1month',
  SIX_MONTHS: '6months',
  YEAR: '1year',
  MAX: '5years',
};

/**
 * Resolves a period key to a display string using translations.
 */
export const resolvePeriodText = (
  key: string | undefined,
  translations: PerformanceDisclaimerTranslations,
): string => {
  if (!key) return '24h';

  const resolver = periodResolvers[key];

  return resolver ? resolver(translations) : '24h';
};
